import {asyncCall} from "./call";

export interface RemoteControlSetpoint {
	index: number;
	subIndex: number;
	value: number;
}
export interface SetRemoteControlValue {
	deviceId: number;
	index: number;
	subIndex: number;
	min: number;
	max: number;
}
export interface RCLastChange {
	id: number
	username: string
	email: string
	lastTimeChanged: number
}
export interface RCData {
	index: number
	subIndex: number
	name: string
	group: string
	deviceMin: number
	deviceMax: number
	allowedMin: number
	allowedMax: number
	adminDefinedMin: number
	adminDefinedMax: number
	hasCurrentSetpoint: boolean
	currentSetPoint: number
	hasPendingChange: boolean
	pendingValue: number
	decimals: number
	step: number
	unit: string
	lastTimeChangedBy: RCLastChange
}

export interface OPModes {
	name: string
	key: string
}

export interface RCResponse {
	deviceId: number
	deviceName: string
	values: RCData[]
}

export interface RCAdminResponse
	extends RCResponse {
	sn: string
	deviceType: string
	online: boolean
}
export class RemoteControlConnector {
	urlPrefix: string
	sessionID: string
	constructor(
		urlPrefix: string,
		sessionID: string
	) {
		this.urlPrefix =
			urlPrefix
		this.sessionID =
			sessionID
	}

	/**
	 * @target /api/accept-rc-sla
	 */
	async acceptRCSLA() {
		const result =
			await asyncCall(
				this
					.urlPrefix +
					"/api/accept-rc-sla",
				{
					session: this
						.sessionID,
				}
			)
		return result
	}

	/**
	 * @target /api/store-totp-code
	 * @returns
	 */
	async saveOTP(
		otp: string
	) {
		const result =
			await asyncCall(
				this
					.urlPrefix +
					"/api/store-totp-code",
				{
					session: this
						.sessionID,
					totp: otp,
				}
			)
		return result
	}

	/**
	 *
	 * @param deviceId
	 * @param index
	 * @param subIndex
	 * @returns
	 */
	async getRCInfo(
		deviceId: number,
		index?: number,
		subIndex?: number
	) {
		const result =
			await asyncCall(
				this
					.urlPrefix +
					"/api/get-device-limit",
				{
					session: this
						.sessionID,
					deviceId,
					index,
					subIndex,
				}
			)
		return result as RCResponse
	}

	/**
	 * @target /api/set-setpoints
	 * @param data
	 * @param code
	 */
	async setRCValue(
		values: {
			deviceId: number
			index: number
			subIndex: number
			value: number
		}[],
		code: string
	) {
		const result =
			await asyncCall(
				this
					.urlPrefix +
					"/api/set-setpoints",
				{
					session: this
						.sessionID,
					code,
				},
				values
			)
		return result
	}

	/**
	 * @target /api/set-device-limit?
	 * @param options
	 * @param code
	 * @returns
	 */
	async setRC(
		data: SetRemoteControlValue[],
		code: string
	) {
		const result =
			await asyncCall(
				this
					.urlPrefix +
					"/api/set-device-limit",
				{
					session: this
						.sessionID,
					code,
				},
				data
			)
		return result
	}

	/**
	 * @target api/get-contract-device-limits-with-access
	 * @returns
	 */
	async getContractDevices() {
		const result =
			await asyncCall(
				this
					.urlPrefix +
					"/api/get-contract-device-limits-with-access",
				{
					session: this
						.sessionID,
				}
			)
		return result
	}

	/**
	 * @target /api/get-setpoint-overview
	 * @returns
	 **/
	async getRemoteControlOverview() {
		const result =
			await asyncCall(
				this
					.urlPrefix +
					"/api/get-setpoint-overview",
				{
					session: this
						.sessionID,
				}
			)

		return result
	}
}
